import React, { useState } from "react";
import Comunidades from "./components/comunidades";
import Provincias from "./components/provincias";
import Municipios from './components/municipios';

let comunidadSeleccionada, provinciaSeleccionada;


const ComboApp = () => {

  const [comunidadesValue, setComunidadesValue] = useState("");
  const [ProvinciasOpciones, setProvinciasOpciones] = useState([]);
  const [MunicipiosOpciones, setMunicipiosOpciones] = useState([]);

  const handleComunidadesChange = (event) => {

    let comunidades = [];

    const selectedValue = event.target.value;
    comunidadSeleccionada = selectedValue;

    comunidades.push(comunidadSeleccionada);

    // Limpiamos siempre porque si cambia, cambian los municipios
    // Cargamos el segundo combo y ya se verá

    // Da igual que se la opción 0.

    document.getElementById("mensaje").innerHTML = ``;

    setComunidadesValue(selectedValue);
    setProvinciasOpciones(selectedValue);

    switch (selectedValue) {
      case "Euskadi":
        setProvinciasOpciones(["Araba", "Gipuzkoa", "Bizkaia"]);
        break;
      case "Canarias":
        setProvinciasOpciones(["Las Palmas", "Tenerife"]);
        break;
      case "Aragon":
        setProvinciasOpciones(["Zaragoza", "Huesca", "Teruel"]);
        break;
      default:
        setProvinciasOpciones([]);
    }

    setMunicipiosOpciones([]);
    
  };

  const handleProvinciasChange = (event) => {

    let provincias = [];
    document.getElementById("mensaje").innerHTML = ``;
    const selectedValue = event.target.value;
    provinciaSeleccionada = selectedValue;

    provincias.push(provinciaSeleccionada);

    switch (selectedValue) {
      case "Araba":
        setMunicipiosOpciones(["Gasteiz", "La Guardia", "Oion"]);
        break;
      case "Gipuzkoa":
        setMunicipiosOpciones(["Donosti","Arrasate", "Eibar"]);
        break;
      case "Bizkaia":
        setMunicipiosOpciones(["Bilbo", "Barakaldo", "Durango"]);
        break;
      case "Las Palmas":
        setMunicipiosOpciones(["Las Palmas", "Puerto del Rosario", "Arrecife"]);
        break;
      case "Tenerife":
        setMunicipiosOpciones(["Santa Cruz","Arona", "Adeje"]);
          break;
      case "Zaragoza":
         setMunicipiosOpciones(["Zaragoza", "Caspe", "Luesma"]);
         break;
      case "Huesca":
        setMunicipiosOpciones(["Huesca", "Benasque", "Jaca"]);
         break;
      case "Teruel":
        setMunicipiosOpciones(["Teruel","Alcañiz", "Monreal del Campo"]);
         break;
      default:
        setMunicipiosOpciones([]);
    }
    

  };

  const handleMunicipiosChange = (event) => {
    const selectedValue = event.target.value;

    if (selectedValue.length > 0) {
      document.getElementById("mensaje").innerHTML = 
             `<br>El municipio seleccionado es <b>${selectedValue}</b>
                en la provincia de <b>${provinciaSeleccionada}</b> 
                de la Comunidad Autónoma de <b>${comunidadSeleccionada}</b>`;
    } else {
      document.getElementById("mensaje").innerHTML = ``;

    }
  };

  return (
    <>
      <div>
        <Comunidades handleChange={handleComunidadesChange} />{" "}
        <br/>
        <Provincias opciones={ProvinciasOpciones} handleChange={handleProvinciasChange} />{" "}
        <br/>
        <Municipios opciones={MunicipiosOpciones} handleChange={handleMunicipiosChange} />{" "}
      </div>{" "}
      <div id="mensaje"> </div>{" "}
    </>
  );
};

export default ComboApp;
